(() => {
  const root = window;
  let zlog = root?.zlog;
  if (!zlog) {
    window.zlog = {};
    zlog = window.zlog;
  }
  const identity = window.jjbUtils.getIdentity();
  const contexts = {
    ga4: {
      device_id: identity.anonymousId,
      customer_id: identity.customerId,
    },
    monitor: {},
    statsig: {},
  };
  const experimentGroups = new Map();

  const setContext = (platform, context, mode = 'merge') => {
    if (mode === 'clear' || context === null) {
      contexts[platform] = {};
      return;
    }
    contexts[platform] =
      mode === 'replace'
        ? { ...(context || {}) }
        : { ...contexts[platform], ...(context || {}) };
  };

  zlog.setGa4TrackingContext = (context, mode) =>
    setContext('ga4', context, mode);
  zlog.setMonitorTrackingContext = (context, mode) =>
    setContext('monitor', context, mode);
  zlog.setStatsigTrackingContext = (context, mode) =>
    setContext('statsig', context, mode);
  zlog.recordExperimentGroup = (experimentKey, groupId) => {
    if (
      typeof experimentKey === 'string' &&
      experimentKey.trim() &&
      Number.isInteger(groupId) &&
      groupId > 0
    ) {
      experimentGroups.set(experimentKey, groupId);
    }
    return Array.from(experimentGroups.values());
  };
  zlog.flushTracking = () => {
    root.Monitor?.flush?.();
  };

  const getAdsSendTo = (eventName) => {
    if (!root.GOOGLE_ADS_ID) return '';
    const labels = {
      add_to_cart: root.GOOGLE_ADS_ADD_TO_CART_LABEL || '',
      begin_checkout: root.GOOGLE_ADS_BEGIN_CHECKOUT_LABEL || '',
    };
    return labels[eventName]
      ? `${root.GOOGLE_ADS_ID}/${labels[eventName]}`
      : '';
  };

  zlog.track = async (eventName, params = {}, options = {}) => {
    const tasks = [];

    if (options.ga4 !== false) {
      const payload = {
        ...contexts.ga4,
        ...params,
        membership_level: window?.theme?.membershipPlan || 'BASIC',
      };
      const currentExperimentGroups = Array.from(experimentGroups.values());
      if (currentExperimentGroups.length) {
        payload.experimentGroups = currentExperimentGroups.join('-');
      } else {
        delete payload.experimentGroups;
      }
      const adsSendTo = options.includeAds ? getAdsSendTo(eventName) : '';
      if (adsSendTo) {
        payload.send_to = adsSendTo;
      } else if (window.GA_MEASUREMENT_ID) {
        payload.send_to = window.GA_MEASUREMENT_ID;
      }
      if (typeof root.gtag === 'function' && options.awaitGa4) {
        tasks.push(
          new Promise((resolve) => {
            const timeout = root.setTimeout(resolve, 1000);
            payload.event_callback = () => {
              root.clearTimeout(timeout);
              resolve();
            };
            try {
              root.gtag('event', eventName, payload);
            } catch (_error) {
              root.clearTimeout(timeout);
              resolve();
            }
          }),
        );
      } else if (typeof root.gtag === 'function') {
        tasks.push(
          Promise.resolve().then(() => root.gtag('event', eventName, payload)),
        );
      } else if (Array.isArray(root.dataLayer)) {
        root.dataLayer.push({ event: eventName, ...payload });
      }
    }
    if (
      options.monitor !== false &&
      typeof root.Monitor?.track === 'function'
    ) {
      const payload = { ...contexts.monitor, ...params };
      delete payload.experimentGroups;
      tasks.push(
        Promise.resolve().then(() => root.Monitor.track(eventName, payload)),
      );
    }
    if (
      options.statsig !== false &&
      typeof root.statsigClient?.logEvent === 'function'
    ) {
      const payload = { ...contexts.statsig, ...params };
      delete payload.experimentGroups;
      const value =
        options.statsigValue === undefined ? null : options.statsigValue;
      tasks.push(
        Promise.resolve().then(() =>
          root.statsigClient.logEvent(eventName, value, payload),
        ),
      );
    }

    await Promise.allSettled(tasks);
  };
})();
